import axios from 'axios'
import { FINALIZAR_ENTREGA_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function finalizarEntregaEncomenda (idEncomenda, idEmpresa, observacao) {

  const url = `${URL}/encomendas/${idEncomenda}/empresa/${idEmpresa}/finalizar-entrega`;
  return dispatch => axios.post(url, { observacao }, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: FINALIZAR_ENTREGA_ENCOMENDA,
        payload: response

      })
  );
}
